import { render, staticRenderFns } from "./AppTreeView.vue?vue&type=template&id=37b570d2"
import script from "./AppTreeView.vue?vue&type=script&lang=js"
export * from "./AppTreeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports